export default "__VITE_ASSET__t237j34L__"